/* eslint-disable no-underscore-dangle */
import { getRandomID } from 'Utils/generatorUtils';

const DEBUG_LEVEL_NAME = 'debug';
const ERROR_LEVEL_NAME = 'error';
const INFO_LEVEL_NAME = 'info';
const WARN_LEVEL_NAME = 'warn';

const priorityLevels: Record<string, number> = {
  [DEBUG_LEVEL_NAME]: 3,
  [ERROR_LEVEL_NAME]: 0,
  [INFO_LEVEL_NAME]: 2,
  [WARN_LEVEL_NAME]: 1,
};

export type OptionalInfoProp = {
  datasource?: never;
} & Record<string, unknown>;

// eslint-disable-next-line import/prefer-default-export
export class LoggerService {
  private _id: string;

  private _priority: number;

  private _adapters: object[];

  private _domainName?: string;

  constructor(logPriority: number, domainName?: string) {
    this._id = getRandomID();
    this._priority = logPriority;
    this._adapters = [];
    this._domainName = domainName;
  }

  addAdapters(...providerAdapters: object[]): void {
    this._adapters = [...this._adapters, ...providerAdapters];
  }

  debug(message: string, datasource: string, optionalInfo?: OptionalInfoProp) {
    this._log(DEBUG_LEVEL_NAME, message, datasource, optionalInfo);
  }

  info(message: string, datasource: string, optionalInfo?: OptionalInfoProp) {
    this._log(INFO_LEVEL_NAME, message, datasource, optionalInfo);
  }

  warn(message: string, datasource: string, optionalInfo?: OptionalInfoProp) {
    this._log(WARN_LEVEL_NAME, message, datasource, optionalInfo);
  }

  error(message: string, datasource: string, optionalInfo?: OptionalInfoProp) {
    this._log(ERROR_LEVEL_NAME, message, datasource, optionalInfo);
  }

  _log(level: string, message: string, datasource: string, optionalInfo: OptionalInfoProp = {}) {
    if (!level || !message || !datasource) throw new Error('LoggerService requires a message and a trail');

    if (this._priority >= priorityLevels[level]) {
      const { trackingId, ...otherParams } = optionalInfo;
      const id = trackingId || this._id;

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this._adapters.forEach((adapter: any) => {
        adapter[level](id, message, { datasource, domain: this._domainName, ...otherParams });
      });
    }
  }
}
